import { DocumentoField } from '@components/Fields/DocumentoField';
import { StringField } from '@components/Fields/StringField';
import { TelefoneField } from '@components/Fields/TelefoneField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IForm } from '@hooks/useForm';
import { IVendedorRegistrar } from '@services/VendedorService';
import React from 'react';

export type VendedorRegistrarFormProps = {
    form: IForm<IVendedorRegistrar>
}

export function VendedorRegistrarForm ({ form }: VendedorRegistrarFormProps) {
    const { fields } = form;

    return (
        <HorizontalGrid spacing={1}>
            <GridItem xs={12}>
                <StringField 
                    field={fields.nome}
                    label="Nome"
                />
            </GridItem>

            <GridItem xs={6}>
                <DocumentoField
                    maskType="cpf" 
                    field={fields.cpf}
                    label="CPF"
                />
            </GridItem>

            <GridItem xs={6}>
                <TelefoneField
                    maskType="cel" 
                    field={fields.telefone}
                    label="Telefone"
                />
            </GridItem>
        </HorizontalGrid>
    )
}